import { inject, Injectable } from '@angular/core';
import { LayoutService } from '../../../core/services/layout.service';
import { combineLatest, Observable } from 'rxjs';
import { MoldViewApiService } from '../api/view.service';
import { MatDialog } from '@angular/material/dialog';
import { SingleDepartmentService } from '../../../shared/services/single-department.service';
import { MoldRevisionItem } from '../../../common/mold/models/item';
import { MoldContainerService } from '../../../common/mold/services/container.service';
import {
  MoldFormDialogComponent,
  MoldFormDialogTypes,
} from '../../../common/mold/dialog/form/form.component';

@Injectable()
export class MoldsViewService<Type extends MoldRevisionItem> {
  protected readonly containerService = inject(MoldContainerService);
  protected readonly layoutService = inject(LayoutService);
  protected readonly apiRouter = inject(MoldViewApiService);
  protected readonly dialog = inject(MatDialog);
  protected readonly departmentService = inject(SingleDepartmentService);

  protected columns = ['name', 'location', 'status', 'options'];
  get displayedColumns(): string[] {
    return [...this.columns];
  }

  update(): void {
    this.layoutService.setLoading(true);
    combineLatest([
      this.apiRouter.getMolds(),
      this.apiRouter.getMachines(),
    ]).subscribe(
      ([res, machines]) => {
        this.containerService.moldList = res;
        this.containerService.machines = machines;
        this.layoutService.setLoading(false);
      },
      (err) => {
        console.log(err);
        this.layoutService.setLoading(false);
      }
    );
  }
  updateDialog(): void {
    this.layoutService.setLoading(true);
    combineLatest([this.apiRouter.getMolds()]).subscribe(
      ([res]) => {
        this.containerService.moldList = res;

        this.layoutService.setLoading(false);
      },
      (err) => {
        console.log(err);
        this.layoutService.setLoading(false);
      }
    );
  }

  updateMoldDialog(
    molds: Type['mold'][],
    item: Type
  ): Observable<MoldFormDialogTypes['return']> {
    return this.dialog
      .open(MoldFormDialogComponent, {
        data: {
          molds,
          moldRevision: item,
          type: 'edit',
          department: this.departmentService.NAME,
        },
      })
      .afterClosed();
  }
}
